<div class="edit-container">
    <div class="d-flex justify-content-between align-items-center mb-4">
        <h1 class="edit-title m-0 p-0">Editare programări modul</h1>
        <button type="button" class="close" aria-label="Close" (click)="closeDialog()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <span class="text-center">
        <h2>Modul: {{moduleName}}</h2>
        <h2>Locație: {{locatieName}}</h2>
    </span>

    <mat-button-toggle-group class="mb-3" name="fontStyle" aria-label="Font Style" (change)="onToggleChange($event)"
        value="configurare">
        <mat-button-toggle value="configurare">Configurare</mat-button-toggle>
        <mat-button-toggle value="disponibilitate">Disponibilitate</mat-button-toggle>
    </mat-button-toggle-group>

    <ng-container *ngIf="selectedToggleStatus === 'configurare'">
        <h3>Servicii > Tip Problemă</h3>
        <div class="row pb-3" *ngFor="let row of stateRows">
            <mat-expansion-panel [expanded]="row.cereri_types.length > 0" [disabled]="row.cereri_types.length === 0">
                <mat-expansion-panel-header class="group-header">
                    <mat-panel-title>
                        <mat-checkbox color="primary" [(ngModel)]="row.checked"
                            (click)="updateCheckedList(row, true); $event.stopPropagation()">
                            {{ row.label }}
                        </mat-checkbox>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div>
                    <div *ngFor="let cerere of row.cereri_types" class="checkbox ps-5">
                        <mat-checkbox color="primary" [(ngModel)]="cerere.checked" (click)="updateCheckedList(cerere)">
                            <span [ngClass]="{ 'text-danger': !cerere.public_view }">{{ cerere.name }}</span>
                        </mat-checkbox>
                    </div>
                </div>
            </mat-expansion-panel>
        </div>
    </ng-container>

    <ng-container *ngIf="selectedToggleStatus === 'disponibilitate'">
        <h3>Program Tipuri Problemă:</h3>
        <mat-accordion>
            <ng-container *ngFor="let row of stateRows">
                <mat-expansion-panel class="mb-2" *ngIf="row.checked">
                    <mat-expansion-panel-header class="group-header">
                        <mat-panel-title>
                            {{ row.original_label }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <mat-accordion *ngIf="tipuriProgramByServiciu[row.id]?.length > 0; else noTipuriProgram">
                        <mat-expansion-panel *ngFor="let tipProgram of tipuriProgramByServiciu[row.id]">
                            <mat-expansion-panel-header
                                class="group-header d-flex justify-content-between align-items-center">
                                <mat-panel-title>
                                    {{ tipProgram.program_type.name }}
                                </mat-panel-title>
                                <button (click)="deleteTipProgram(tipProgram.id)" type="button"
                                    class="action-btn delete me-5">
                                    <img class="btn-img" src="/assets/icons/delete.svg" alt="delete" />
                                </button>
                            </mat-expansion-panel-header>
                            <ng-container
                                *ngIf="initializeTimeCursor(row.id, tipProgram.program_type.id, selectedDayID)">
                                <ng-container *ngFor="let locatieServiciu of [filteredLocatiiServiciiMap[row.id]]">
                                    <div class="program-content">
                                        <div class="d-flex flex-wrap gap-2 mb-3">
                                            <button *ngFor="let day of daysOfWeek" type="button" class="action-button"
                                                (click)="selectDay(day.id_day)"
                                                [class.active-day]="selectedDayID === day.id_day">
                                                <span>{{day.day}}</span>
                                            </button>
                                        </div>
                                        <p>Intervale disponibile:</p>
                                        <div class="d-flex justify-content-between flex-wrap gap-2">
                                            <div class="row">
                                                <div class="col">
                                                    <mat-form-field class="" appearance="fill">
                                                        <mat-label>Ora</mat-label>
                                                        <mat-select
                                                            [(ngModel)]="timeCursors[generateKey(row.id, tipProgram.program_type.id, selectedDayID)].hour">
                                                            <mat-option *ngFor="let hour of possibleHours"
                                                                [value]="hour">
                                                                {{ hour }}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                                <div class="col">
                                                    <mat-form-field class="" appearance="fill">
                                                        <mat-label>Minutul</mat-label>
                                                        <mat-select
                                                            [(ngModel)]="timeCursors[generateKey(row.id, tipProgram.program_type.id, selectedDayID)].minute">
                                                            <mat-option
                                                                *ngFor="let minute of possibleMinutesMap[row.id + '_' + tipProgram.program_type.id]"
                                                                [value]="minute">
                                                                {{ minute }}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <button type="button" class="my-2 action-button"
                                                (click)="addTime(row.id, tipProgram.program_type.id, formGroupsMap[row.id + '_' + tipProgram.program_type.id].get('durata_programare')?.value)">
                                                <span>Adaugă</span>
                                            </button>
                                        </div>
                                        <div class="d-flex justify-content-between flex-wrap gap-2">
                                            <mat-chip-listbox aria-label="Time selection">
                                                <ng-container *ngFor="let time of timeData; index as timeIndex">
                                                    <mat-chip *ngIf="time.id_serviciu === row.id && 
                                                            time.id_program_type === tipProgram.program_type.id &&
                                                            time.day === selectedDayID &&
                                                            !time.deleted">
                                                        {{ time.hour }}:{{ time.minute }}
                                                        <button type="button" matChipRemove aria-label="Remove time"
                                                            (click)="removeTime(timeIndex)">
                                                            <mat-icon>cancel</mat-icon>
                                                        </button>
                                                    </mat-chip>
                                                </ng-container>
                                            </mat-chip-listbox>
                                        </div>
                                        <ng-container *ngIf="row.checked">
                                            <form
                                                [formGroup]="formGroupsMap[row.id + '_' + tipProgram.program_type.id]">
                                                <div class="row mt-3">
                                                    <mat-form-field class="col-md-6" appearance="fill">
                                                        <mat-label>Durată interval blocare</mat-label>
                                                        <mat-select formControlName="durata_interval_blocare">
                                                            <mat-option *ngFor="let row of durataOptions"
                                                                [value]="row.value">
                                                                {{ row.name }}
                                                            </mat-option>
                                                        </mat-select>
                                                        <!-- <mat-error
                                                            *ngIf="isInvalid(formGroupsMap[row.id], 'durata_interval_blocare')">
                                                            Acest câmp este obligatoriu
                                                        </mat-error> -->
                                                    </mat-form-field>

                                                    <mat-form-field class="col-md-6" appearance="fill">
                                                        <mat-label>Durată programare</mat-label>
                                                        <mat-select formControlName="durata_programare">
                                                            <mat-option *ngFor="let row of durataOptions"
                                                                [value]="row.value">
                                                                {{ row.name }}
                                                            </mat-option>
                                                        </mat-select>
                                                        <!-- <mat-error
                                                            *ngIf="isInvalid(formGroupsMap[row.id], 'durata_programare')">
                                                            Acest câmp este obligatoriu
                                                        </mat-error> -->
                                                    </mat-form-field>
                                                </div>

                                                <div class="row">
                                                    <mat-form-field class="col-md-6">
                                                        <mat-label>Prima dată valabilă</mat-label>
                                                        <input matInput [matDatepicker]="minDatePicker"
                                                            formControlName="min_date_available" readonly
                                                            (focus)="minDatePicker.open()" />
                                                        <mat-hint>ZZ/LL/AAAA</mat-hint>

                                                        <mat-datepicker-toggle matIconSuffix
                                                            [for]="minDatePicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #minDatePicker></mat-datepicker>

                                                        <!-- <mat-error
                                                            *ngIf="isInvalid(formGroupsMap[row.id], 'min_date_available')">
                                                            Acest câmp este obligatoriu
                                                        </mat-error>
                                                        <mat-error
                                                            *ngIf="!isInvalid(formGroupsMap[row.id], 'min_date_available') && !isInvalid(formGroupsMap[row.id], 'max_date_available') && formGroupsMap[row.id]?.errors?.dateRangeInvalid">
                                                            Data de început trebuie să fie mai mică decât data de
                                                            sfârșit.
                                                        </mat-error> -->
                                                    </mat-form-field>

                                                    <mat-form-field class="col-md-6">
                                                        <mat-label>Ultima dată valabilă</mat-label>
                                                        <input matInput [matDatepicker]="maxDatePicker"
                                                            formControlName="max_date_available" readonly
                                                            (focus)="maxDatePicker.open()"
                                                            name="maxDatePicker_{{row.id}}" />
                                                        <mat-hint>ZZ/LL/AAAA</mat-hint>

                                                        <mat-datepicker-toggle matIconSuffix
                                                            [for]="maxDatePicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #maxDatePicker></mat-datepicker>
                                                        <mat-error
                                                            *ngIf="formGroupsMap[row.id + '_' + tipProgram.program_type.id].get('max_date_available')?.hasError('invalidDateRange')">
                                                            Selectați o perioadă validă
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </form>
                                        </ng-container>
                                    </div>

                                </ng-container>

                            </ng-container>

                        </mat-expansion-panel>
                    </mat-accordion>
                    <ng-template #noTipuriProgram>
                        <h4 class="mt-2 mb-0 text-center">
                            Generați minim un tip de program
                            activ pentru acest modul!
                        </h4>
                        <form class="mt-3" [formGroup]="createFormForServiciu(row.id)"
                            (submit)="submitTipProgram(row.id)">
                            <div class="row">
                                <div class="col">
                                    <mat-form-field class="w-100" appearance="fill">
                                        <mat-label>Tip Program</mat-label>
                                        <mat-select formControlName="id_program_type">
                                            <mat-option value="-1">-- Alegeți --</mat-option>
                                            <mat-option *ngFor="let tip of tipuriProgram" [value]="tip.id">
                                                {{ tip.name }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="!formsByServiciu[row.id].controls['id_program_type'].valid && formsByServiciu[row.id].controls['id_program_type'].touched">
                                            Câmp obligatoriu
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100" appearance="fill">
                                        <mat-label>Durată interval blocare</mat-label>
                                        <mat-select formControlName="durata_interval_blocare">
                                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                                            <mat-option *ngFor="let row of durataOptions" [value]="row.value">
                                                {{ row.name }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="!formsByServiciu[row.id].controls['durata_interval_blocare'].valid && formsByServiciu[row.id].controls['durata_interval_blocare'].touched">
                                            Câmp obligatoriu
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <mat-form-field class="w-100" appearance="fill">
                                        <mat-label>Durată programare</mat-label>
                                        <mat-select formControlName="durata_programare">
                                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                                            <mat-option *ngFor="let row of durataOptions" [value]="row.value">
                                                {{ row.name }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="!formsByServiciu[row.id].controls['durata_programare'].valid && formsByServiciu[row.id].controls['durata_programare'].touched">
                                            Câmp obligatoriu
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Prima dată valabilă</mat-label>
                                        <input matInput [matDatepicker]="minDatePicker"
                                            formControlName="min_date_available" readonly
                                            (focus)="minDatePicker.open()" />
                                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix
                                            [for]="minDatePicker"></mat-datepicker-toggle>
                                        <mat-datepicker #minDatePicker></mat-datepicker>
                                        <mat-error
                                            *ngIf="!formsByServiciu[row.id].controls['min_date_available'].valid && formsByServiciu[row.id].controls['min_date_available'].touched">
                                            Câmp obligatoriu
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Ultima dată valabilă</mat-label>
                                        <input matInput [matDatepicker]="maxDatePicker"
                                            formControlName="max_date_available" readonly
                                            (focus)="maxDatePicker.open()" />
                                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix
                                            [for]="maxDatePicker"></mat-datepicker-toggle>
                                        <mat-datepicker #maxDatePicker></mat-datepicker>
                                        <mat-error
                                            *ngIf="!formsByServiciu[row.id].controls['max_date_available'].valid && formsByServiciu[row.id].controls['max_date_available'].touched && !formsByServiciu[row.id].controls['max_date_available'].hasError('invalidDateRange')">
                                            Câmp obligatoriu
                                        </mat-error>
                                        <mat-error
                                            *ngIf="formsByServiciu[row.id].controls['max_date_available'].hasError('invalidDateRange')">
                                            Selectați o perioadă validă
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col d-flex justify-content-end">
                                    <button class="buttons" mat-flat-button color="primary" type="submit">
                                        Adaugă
                                    </button>
                                </div>
                            </div>
                        </form>
                    </ng-template>
                </mat-expansion-panel>
            </ng-container>
        </mat-accordion>
    </ng-container>

    <div class="row">
        <div class="col d-flex justify-content-between">
            <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                {{ helper.dialogConfig.buttonLabels.close }}
            </button>
            <button class="buttons" type="button" mat-flat-button color="primary" [disabled]="isLoading"
                (click)="updateTimesModul()">
                {{ helper.dialogConfig.buttonLabels.save }}
            </button>
        </div>
    </div>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>